import React, { useState, useEffect, useRef } from "react";
import WaveSurfer from "wavesurfer.js";
import styles from "./VoiceTag.module.scss";
import Button from "../forms/button/Button";

const VoiceTag = () => {
  const [audioBlob, setAudioBlob] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const wavesurferRef = useRef(null);

  useEffect(() => {
    wavesurferRef.current = WaveSurfer.create({
      container: "#waveform",
      waveColor: "lightblue",
      progressColor: "green",
      cursorColor: "#000",
      height: 35,
    });

    return () => {
      if (wavesurferRef.current) wavesurferRef.current.destroy();
    };
  }, []);

  useEffect(() => {
    if (audioBlob) {
      const url = URL.createObjectURL(audioBlob);
      wavesurferRef.current.load(url);

      wavesurferRef.current.on("ready", () => {
        setDuration(wavesurferRef.current.getDuration());
      });

      wavesurferRef.current.on("audioprocess", () => {
        setCurrentTime(wavesurferRef.current.getCurrentTime());
      });

      wavesurferRef.current.on("finish", () => {
        setIsPlaying(false);
      });
    }
  }, [audioBlob]);

  const togglePlayPause = () => {
    if (isPlaying) {
      wavesurferRef.current.pause();
      setIsPlaying(false);
    } else {
      wavesurferRef.current.play();
      setIsPlaying(true);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div className={styles["voice-tag"]}>
      <p>{`${isPlaying ? formatTime(currentTime) : formatTime(duration)}`}</p>
      <div id="waveform" className={styles.waveform}></div>
      <Button
        type={isPlaying ? "pause" : "play"}
        className={styles["audio-button"]}
        onClick={togglePlayPause}
        isDisabled={!audioBlob}
      />
    </div>
  );
};

export default VoiceTag;
